import { observer } from "mobx-react-lite";
import React from "react";
import { Checkbox as BSCheckbox } from "react-bootstrap";
import { useFormContext } from "./Form";
import { withFormWrapper } from "./withFormWrapper";
import { StaticCheckbox } from "./StaticInput";
import { classNames } from "./utils/classNames";
export var CheckedStates;
(function (CheckedStates) {
    CheckedStates["Checked"] = "checked";
    CheckedStates["Indeterminate"] = "indeterminate";
    CheckedStates["Unchecked"] = "unchecked";
})(CheckedStates || (CheckedStates = {}));
const RawCheckbox = observer(({ name, onChange, description, disabled, label, staticFormatter, descriptionHidden, dataId, dataLabel, dataTestId, }) => {
    const { values, formDisabled, isStatic } = useFormContext();
    const handleChange = React.useCallback((e) => {
        if (onChange) {
            onChange(e.target.checked, values.get(e.target.name));
        }
        values.set(e.target.name, e.target.checked);
    }, [onChange, values]);
    if (isStatic && !descriptionHidden) {
        return (React.createElement(StaticCheckbox, { name: name, label: description, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    const checkboxValue = values.get(name);
    const isChecked = checkboxValue === true || checkboxValue === "true";
    return (React.createElement(BSCheckbox, { name: name, checked: isChecked, onChange: handleChange, disabled: disabled || formDisabled },
        label && `${label} - `,
        React.createElement("span", { className: classNames(descriptionHidden ? "sr-only" : "") }, description)));
});
export const Checkbox = withFormWrapper({
    WrappedComponent: RawCheckbox,
    options: "checkbox",
});
